import { Component, Input, Output, EventEmitter } from '@angular/core';

import { normalizeSearchText } from '../../utils/text-normalization.util';

export interface ProfileViewModel {
  uuid: string;
  name: string;
  organizationCount: number;
  isDefault: boolean;
}

@Component({
  selector: 'app-profiles-table',
  standalone: false,
  templateUrl: './profiles-table.component.html',
  styleUrls: ['./profiles-table.component.scss'],
})
export class ProfilesTableComponent {
  @Input() profiles: ProfileViewModel[] = [];
  @Input() translationPrefix = '';
  @Input() iconSrc = '';

  @Output() addNew = new EventEmitter<void>();
  @Output() edit = new EventEmitter<ProfileViewModel>();
  @Output() delete = new EventEmitter<ProfileViewModel>();
  @Output() toggleDefault = new EventEmitter<ProfileViewModel>();
  @Output() back = new EventEmitter<void>();

  searchQuery = '';

  get filteredProfiles(): ProfileViewModel[] {
    if (!this.searchQuery.trim()) return this.profiles;
    const q = normalizeSearchText(this.searchQuery);
    return this.profiles.filter((p) => normalizeSearchText(p.name).includes(q));
  }

  t(key: string): string {
    return `${this.translationPrefix}.${key}`;
  }
}
